import React, { useState } from "react";
import { Formik, Form, Field, ErrorMessage } from "formik";
import * as Yup from "yup";
import products from "../data/products.json";

const ComplaintForm = () => {
  const [selectedComplaintType, setSelectedComplaintType] = useState("");
  const initialValues = {
    phone: "",
    contactPerson: "",
    companyName: "",
    city: "",
    state: "",
    complaintType: "",
    complaintCategory: "",
    remark: "",
  };

  const validationSchema = Yup.object({
    phone: Yup.string().required("Phone is required"),
    contactPerson: Yup.string().required("Contact person is required"),
    companyName: Yup.string().required("Company name is required"),
    city: Yup.string().required("City is required"),
    state: Yup.string().required("State is required"),
    complaintType: Yup.string().required("Complaint type is required"),

    remark: Yup.string(),
  });

  const hardwareCat = [
    "TIME ATTENDANCE AND ACCESS CONTROL",
    "ENTRANCE CONTROL",
    "PARKING AND TRAFFIC CONTROL",
    "INSPECTION CONTROL",
  ];
  const softwareCat = ["SOFTWARE AND APPLICATIONS"];

  const onSubmit = (values) => {
    console.log("Form data", values);
  };
  console.log("products", products);

  return (
    <div className="container mt-5">
      <h3>Complaint Form</h3>
      <Formik
        initialValues={initialValues}
        validationSchema={validationSchema}
        onSubmit={onSubmit}
      >
        {({ values }) => (
          <Form className="row g-3">
             <div className="col-md-6">
              <label className="form-label">Contact Person</label>
              <Field
                name="contactPerson"
                className="form-control"
                placeholder="Enter your name"
              />
              <ErrorMessage
                name="contactPerson"
                component="div"
                className="text-danger"
              />
            </div>

            
            <div className="col-md-6">
              <label className="form-label">Company Name</label>
              <Field
                name="companyName"
                className="form-control"
                placeholder="Enter your company name"
              />
              <ErrorMessage
                name="companyName"
                component="div"
                className="text-danger"
              />
            </div>

            <div className="col-md-6">
              <label className="form-label">Phone</label>
              <Field
                name="phone"
                className="form-control"
                placeholder="Enter your number"
              />
              <ErrorMessage
                name="phone"
                component="div"
                className="text-danger"
              />
            </div> 

            <div className="col-md-6">
              <label className="form-label">City</label>
              <Field
                name="city"
                className="form-control"
                placeholder="Enter your city"
              />
              <ErrorMessage
                name="city"
                component="div"
                className="text-danger"
              />
            </div>

            <div className="col-md-6">
              <label className="form-label">State</label>
              <Field
                name="state"
                className="form-control"
                placeholder="Enter your state"
              />
              <ErrorMessage
                name="state"
                component="div"
                className="text-danger"
              />
            </div>

            <div className="col-md-6">
              <label className="form-label">Complaint Type</label>
              <Field
                as="select"
                name="complaintType"
                className="form-select"
                placeholder="Select compaint type"
              >
                <option value="">Select compaint type</option>
                <option value="software">Software</option>
                <option value="hardware">Hardware</option>
              </Field>
              <ErrorMessage
                name="complaintType"
                component="div"
                className="text-danger"
              />
              {console.log(values.complaintType)}
            </div>
            {values.complaintType == "software" && (
              <div className="col-md-6">
                {console.log("hi")}
                <label className="form-label">Complaint Category</label>
                <Field
                  as="select"
                  name="complaintCategory"
                  className="form-select"
                  placeholder="Select compaint category"
                >
                  <option value="">Select compaint category</option>
                  {softwareCat?.map((cat) => (
                    <option value={cat}>{cat}</option>
                  ))}
                </Field>
                <ErrorMessage
                  name="complaintCategory"
                  component="div"
                  className="text-danger"
                />
              </div>
            )}

            {values.complaintType == "hardware" && (
              <div className="col-md-6">
                <label className="form-label">Complaint Category</label>
                <Field
                  as="select"
                  name="complaintCategory"
                  className="form-select"
                  placeholder="Select compaint category"
                >
                  <option value="">Select compaint category</option>
                  {hardwareCat?.map((cat) => (
                    <option value={cat}>{cat}</option>
                  ))}
                </Field>
                <ErrorMessage
                  name="complaintCategory"
                  component="div"
                  className="text-danger"
                />
              </div>
            )}

            <div className="col-12">
              <label className="form-label">Remark</label>
              <Field
                as="textarea"
                name="remark"
                className="form-control"
                rows="3"
                placeholder="Write about complaint..."
              />
              <ErrorMessage
                name="remark"
                component="div"
                className="text-danger"
              />
            </div>

            <div className="col-12">
              <button type="submit" className="btn btn-primary">
                Submit
              </button>
            </div>
          </Form>
        )}
      </Formik>
    </div>
  );
};

export default ComplaintForm;
